import React, { useState, useEffect } from "react";
import "./ForYou.css";

// News Ticker Component
const ForyouNewsTicker = () => {
  const tickerItems = [
    { title: "Clearview AI", content: "In March 2023, Clearview AI—a facial recognition startup—was fined $25M by Italian regulators for collecting images without proper consent, raising significant privacy concerns." },
    { title: "AnyVision", content: "In January 2023, AnyVision, an AI-powered facial recognition startup, incurred a $3M fine in Israel for mishandling biometric data and violating local data protection laws." },
    { title: "Replika", content: "In February 2023, Replika, an AI chatbot startup, received an official warning from Italy’s Data Protection Authority over concerns regarding its user data security and privacy practices." },
    { title: "HireVue", content: "In April 2023, HireVue, an AI-driven recruitment platform startup, was fined $2.5M by U.S. regulators for potential biases and discrimination issues in its automated interview assessments." },
    { title: "Sighthound", content: "In May 2023, Sighthound, an AI video analytics startup, was fined $1.5M in the EU for failing to implement adequate data protection measures during its video surveillance operations." },
    { title: "Affectiva", content: "In March 2023, Affectiva, an emotion recognition startup, was fined $1.2M by European authorities for misusing emotional data in consumer research without obtaining proper consent." },
    { title: "Automators AI", content: "In August 2023, Automators AI faced a temporary injunction and legal action by the FTC for deploying untested autonomous decision-making systems that raised significant safety and ethical concerns." },
    { title: "Vicarious", content: "In July 2023, Vicarious was fined $900K by U.S. regulators for failing to secure user data properly and for neglecting essential cybersecurity measures in its AI-driven products." },
    { title: "DeepVision", content: "In January 2024, DeepVision was fined $1M by the EU for not providing adequate transparency regarding its data collection methods and processing algorithms, prompting a review of its privacy practices." },
    { title: "Lobe AI", content: "In February 2024, Lobe AI was fined $800K in the U.S. for improper data collection practices and non-compliance with emerging federal data privacy standards." },
  ];

  const [shuffled, setShuffled] = useState([]);

  useEffect(() => {
    setShuffled([...tickerItems].sort(() => Math.random() - 0.5));
  }, []);

  return (
    <div className="foryou-news-ticker">
      <div className="foryou-news-ticker-content">
        {shuffled.map((item, i) => (
          <span key={i} className="foryou-ticker-item">
            <span className="foryou-ticker-dot" />
            <strong>{item.title}:</strong> {item.content}
            <span className="foryou-ticker-separator"> | </span>
          </span>
        ))}
      </div>
    </div>
  );
};

// List of your three programs
const programs = [
  {
    name: "LexTrack AI Batch 2025",
    url: "https://www.f6s.com/lextrack-ai-batch-2025"
  },
  {
    name: "LexTrack AI Batch 2025 Marketing Tech",
    url: "https://www.f6s.com/lextrack-ai-batch-2025-marketing-tech"
  },
  {
    name: "LexTrack AI Batch 2025 Sales Tech",
    url: "https://www.f6s.com/lextrack-ai-batch-2025-sales-tech"
  }
];

const ForYouPage = () => {
  const [showCalendly, setShowCalendly] = useState(false);
  const [showApplyOptions, setShowApplyOptions] = useState(false);

  const handleTalk = () => setShowCalendly(true);
  const handleClose = () => setShowCalendly(false);
  const handleApplyClick = () => setShowApplyOptions(v => !v);

  useEffect(() => {
    if (!showApplyOptions) return;
    const s = document.createElement("script");
    s.src = "https://www.f6s.com/system/js/widgets";
    s.async = true;
    document.body.appendChild(s);
    return () => document.body.removeChild(s);
  }, [showApplyOptions]);

  return (
    <div className="foryou-page">
      <ForyouNewsTicker />

      {/* START ROW */}
      <section className="foryou-start-row">
        <div className="foryou-start-container">
          <div className="foryou-start-content">
            <h1 className="foryou-start-headline">
              Accelerate your business growth<br/>
              with our venture
            </h1>
            <p className="foryou-start-subheadline">
              Lex Accelerator & Incubator connects you with investors, strategic partners, and your first customers to fundraise and expand globally. 🤖
            </p>

            <div className="foryou-start-interactive">
              <button className="foryou-cta-button" onClick={handleTalk}>
                Talk to Us
              </button>
              <span className="foryou-start-separator">Or</span>
              <button className="foryou-apply-button" onClick={handleApplyClick}>
                Apply
              </button>
            </div>

            {showApplyOptions && (
              <div className="foryou-apply-options">
                {programs.map(p => (
                  <a
                    key={p.url}
                    className="f6s-button"
                    href={p.url}
                    target="_blank"
                    rel="noopener"
                    title={`Apply to ${p.name}`}
                  >
                    {p.name}
                  </a>
                ))}
              </div>
            )}

            {showCalendly && (
              <div className="foryou-calendly-dropdown">
                <button className="foryou-close-dropdown-button" onClick={handleClose}>
                  Close
                </button>
                <iframe
                  className="foryou-calendly-embed"
                  src="https://calendly.com/het081-g/30min?embed_type=Inline"
                  frameBorder="0"
                  title="Lex Smart Connect"
                />
              </div>
            )}
          </div>

          <div className="foryou-start-visual">
            <img src="/images/logo10.jpg" alt="Secure Your Startup Growth" />
          </div>
        </div>
      </section>

      {/* BANNER ROWS */}
      <section className="foryou-banner-row">
        <img src="/images/foryoubanner0.png" alt="Banner 0" />
      </section>
      <section className="foryou-banner-row">
        <img src="/images/foryoubanner1.png" alt="Banner 1" />
      </section>
      <section className="foryou-banner-row">
        <img src="/images/foryoubanner2.png" alt="Banner 2" />
      </section>
      <section className="foryou-banner-row">
        <img src="/images/foryoubanner3.png" alt="Banner 3" />
      </section>
      <section className="foryou-banner-row">
        <img src="/images/foryoubanner4.png" alt="Banner 4" />
      </section>
      <section className="foryou-banner-row">
        <img src="/images/foryoubanner5.png" alt="Banner 5" />
      </section>
      <section className="foryou-banner-row">
        <img src="/images/foryoubanner6.png" alt="Banner 6" />
      </section>
      <section className="foryou-banner-row">
        <img src="/images/foryoubanner7.png" alt="Banner 7" />
      </section>
      <section className="foryou-banner-row">
        <img src="/images/foryoubanner8.png" alt="Banner 8" />
      </section>
      <section className="foryou-banner-row">
        <img src="/images/foryoubanner9.png" alt="Banner 9" />
      </section>
      <section className="foryou-banner-row">
        <img src="/images/foryoubanner10.png" alt="Banner 10" />
      </section>
      <section className="foryou-banner-row">
        <img src="/images/foryoubanner11.png" alt="Banner 11" />
      </section>
      <section className="foryou-banner-row">
        <img src="/images/foryoubanner12.png" alt="Banner 12" />
      </section>

      {/* FOOTER */}
      <footer className="foryou-page-footer">
        <p>&copy; {new Date().getFullYear()} LexTrack AI. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default ForYouPage;
